import * as ActionTypes from '../constants/actionTypes'
import { sellerPointsGet, sellerPointsGetCount } from '../api/seller'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.SELLERPOINTLIST_FETCHITEMS_LOAD })

  const payload = { sellerId: params.sellerId }

  sellerPointsGetCount(params, payload).then((res) => {
    const total = parseInt(res.result.n_count)

    sellerPointsGet(params, payload).then((res) => {
      const items = res.result

      dispatch({
        type: ActionTypes.SELLERPOINTLIST_FETCHITEMS_SUCCEED,
        items,
        total,
      })
    }).catch((err) => {
      dispatch({
        type: ActionTypes.SELLERPOINTLIST_FETCHITEMS_FAIL,
        fetchItemsError: 'Ошибка получения списка заведений для торговой сети',
      })
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.SELLERPOINTLIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения кол-ва заведений для торговой сети',
    })
  })
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.SELLERPOINTLIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.SELLERPOINTLIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.SELLERPOINTLIST_SEARCHTABLE_EDIT,
    search,
  })
}



// WEBPACK FOOTER //
// src/actions/sellerPointList.js